import { render, staticRenderFns } from "./consultationUserReqView.vue?vue&type=template&id=969fd296&"
import script from "./consultationUserReqView.vue?vue&type=script&lang=js&"
export * from "./consultationUserReqView.vue?vue&type=script&lang=js&"
import style0 from "./consultationUserReqView.vue?vue&type=style&index=0&id=969fd296&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports